module.exports = __webpack_public_path__ + "img/step_3.f2814304.png";